var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHighshelf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M203.037 63c-8.835 0-21.563 4.505-28.433 10.063l-47.528 38.445c-3.5 2.83-9.024 5.241-14.289 6.492H29.38a4.01 4.01 0 0 0-3.99 3.705v11.643a4.01 4.01 0 0 0 3.99 3.705h83.408c5.265 1.251 10.79 3.661 14.29 6.492l47.527 38.445c6.87 5.558 19.598 10.063 28.433 10.063h23.51a4 4 0 0 0 3.994-4.008v-8.984a4.003 4.003 0 0 0-4.008-4.008H209.04c-6.617 0-16.202-3.341-21.389-7.463l-43.906-34.897c-1.846-1.713-3.845-3.666-5.682-5.168 1.972-1.599 3.762-3.375 5.682-5.166l43.906-34.896C192.837 83.34 202.422 80 209.04 80h17.493a4.003 4.003 0 0 0 4.008-4.008v-8.984A4 4 0 0 0 226.547 63z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighshelf);
export default __webpack_public_path__ + "static/media/highshelf.2a87cf327bf72fb3be1d34c125abbe67.svg";
export { ForwardRef as ReactComponent };